import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { DurationFormatPipe } from '../../../core/pipes/duration-format.pipe';
import { ClosedOrderHeadingStats, closedOrdersTitle } from './closed-orders-title';

@Component({
    selector: 'app-closed-orders',
    templateUrl: './closed-orders.component.html',
    styleUrls: ['./closed-orders.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ClosedOrdersComponent implements OnInit {

  private readonly _basicTitle = 'Heute fertiggestellt';
  private readonly _durationFormat = new DurationFormatPipe();
  public title = this._basicTitle;

  constructor(private _cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  public statsLoaded(stats: ClosedOrderHeadingStats): void {
    this.title = closedOrdersTitle(
      stats,
      seconds => this._durationFormat.transform(seconds)
    );
    this._cdr.detectChanges();
  }

}
